export var pickLiveOrPreliveId = function (marketConfig, isLive) {
    return isLive ? marketConfig.idLive : marketConfig.idPreLive;
};
//# sourceMappingURL=pickLiveOrPreliveId.js.map